export default "__VITE_ASSET__vtZQZUHX__"